<template>
	<div class="media-player flex justify-center flex-direction align-center" v-if="isShow">
		<video-player v-if="type == 'video'" class="video-player vjs-custom-skin" ref="videoPlayer" :playsinline="true" :options="playerOptions"></video-player>
		<!-- <video v-if="type == 'video'" :src="src" :loop="false" ref="video" controls="controls" @play="onPlay" @pause="onPause" @ended="onStop" @error="onError"></video> -->
		<audio v-if="type == 'audio'" :src="src" :loop="false" ref="audio" controls="controls" @play="onPlay" @pause="onPause" @ended="onStop" @error="onError"></audio>
		<img class="close" src="../assets/images/close.png" alt="" @click="close" />
	</div>
</template>

<script>
export default {
	computed: {
		playerOptions() {
			const playerOptionsObj = {
				//playbackRates: [0.7, 1.0, 1.5, 2.0], //播放速度
				autoplay: false, // 如果true,浏览器准备好时开始回放。
				muted: false, // 默认情况下将会消除任何音频。
				loop: false, // 导致视频一结束就重新开始。
				// preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
				language: 'zh-CN',
				// aspectRatio: '16:9', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
				fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
				sources: [
					{
						type: 'video/mp4', // 资源格式写法：'video/mp4'，否则控制台会出现notSupportedMessage设置的错误
						src: this.src // url地址
					}
				],
				poster: this.poster, // 你的封面地址
				width: document.documentElement.clientWidth,
				//height: this.fileAreaHeight,	// 设置高度，fluid需要设置成flase
				notSupportedMessage: '此视频暂无法播放...', // 允许覆盖Video.js无法播放媒体源时显示的默认信息。
				controlBar: {
					timeDivider: true,
					durationDisplay: true,
					remainingTimeDisplay: false,
					fullscreenToggle: true //全屏按钮
				}
			};
			return playerOptionsObj;
		}
	},
	data() {
		return {
			isShow: false,
			type: '',
			src: '',
			poster: ''
			//playerOptions:{}
		};
	},
	methods: {
		onPlay() {
			//this.$store.commit('play');
		},
		onPause() {
			//this.$store.commit('stop');
		},
		onStop() {
			//this.$store.commit('stop');
		},
		onError() {
			//this.$store.commit('stop')
		},
		open(src, type = 'video',poster = '') {
			this.isShow = true;
			this.type = type;
			this.src = src;
			if (type == 'video') {
				this.poster = poster;
			}
		},
		close() {
			if (this.type == 'video') {
				//this.$refs['videoPlayer'].player.stop();
			} else if (this.type == 'audio') {
				//this.$refs['audio'].stop();
			}
			this.type = '';
			this.scr = '';
			this.poster = '';
			this.isShow = false;
			this.$emit('close');
		}
	},
	mounted() {
		let context = this.$refs['music'];
	}
};
</script>

<style lang="scss">
.media-player {
	position: fixed;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	z-index: 999;
	background-color: rgba($color: #000000, $alpha: 0.75);
	audio {
		width: 7rem;
		margin-left: 0.25rem;
		margin-right: 0.25rem;
		box-sizing: border-box;
	}
	// video {
	// 	width: 100%;
	// 	max-height: 100%;
	// }

	.video-player {
		width: 100%;
		max-height: 100%;
		.video-js {
			.vjs-big-play-button {
				top: 50%;
				left: 50%;
				margin-left: -1.5em;
				margin-top: -1.5em;
			}
		}
	}
	.close {
		position: absolute;
		top: 0.2rem;
		right: 0.2rem;
		width: 0.6rem;
		height: 0.6rem;
	}
}
</style>
